import requestStatus from '@/utils/constants/requestStatus';

export const authorizationLetterMessages = {
  letterNotExists: 'letterNotExists',
  documentMissingForThesis: 'documentMissingForThesis',
  documentNotStampedForThesis: 'documentNotStampedForThesis',
};

export const getAuthorizationLetterValidationError = (validation, statusId) => {
  if (!validation?.letterExists) {
    return authorizationLetterMessages.letterNotExists;
  }

  if (statusId === requestStatus.DocumentoTesis && !validation.documentExists) {
    return authorizationLetterMessages.documentMissingForThesis;
  }

  if (
    statusId === requestStatus.DocumentoTesis &&
    !validation.documentStamped
  ) {
    return authorizationLetterMessages.documentNotStampedForThesis;
  }

  return null;
};
